import { makeAutoObservable, runInAction } from 'mobx';
import agent from '../api/agent';
import { CCTipoDeTransaccion, CCTiposDeTransaccionFormValues } from '../models/CCTiposDeTransaccion';

export default class CCTiposDeTransaccionStore {

    CCTipoDeTransaccionRegistry = new Map<any, CCTipoDeTransaccion>();

    selectedCCTipoDeTransaccion: CCTipoDeTransaccion | undefined = undefined;
    editMode = false;
    loading = false;
    loadingInitial = false;
 

    constructor() {
        makeAutoObservable(this)
    }

    get CCTipoDeTransaccionByCodigo() {
        return Array.from(this.CCTipoDeTransaccionRegistry.values());
    }

    loadCCTiposDeTransacciones = async () => {
        this.loadingInitial = true;
        try {
            const CCTiposDeTransacciones: CCTipoDeTransaccion[] = await agent.CCTiposDeTransacciones.list();
            CCTiposDeTransacciones.forEach(CCTipoDeTransaccion => {
                this.setCCTipoDeTransaccion(CCTipoDeTransaccion);
            })
            this.setLoadingInitial(false);
        } catch (error) {
            this.setLoadingInitial(false);
        }
    }

    loadCCTipoDeTransaccion = async (codigoTipoTransaccion: string) => {
        let CCTipoDeTransaccion = this.getCCTipoDeTransaccion(codigoTipoTransaccion);
        if (CCTipoDeTransaccion) {
            this.selectedCCTipoDeTransaccion = CCTipoDeTransaccion;
            return CCTipoDeTransaccion;
        } else {
            this.loadingInitial = true;
            try {
                CCTipoDeTransaccion =  await agent.CCTiposDeTransacciones.details(codigoTipoTransaccion);
                this.setCCTipoDeTransaccion(CCTipoDeTransaccion);
                runInAction(() => {
                    this.selectedCCTipoDeTransaccion = CCTipoDeTransaccion || this.selectedCCTipoDeTransaccion;
                })
                this.setLoadingInitial(false);
                return CCTipoDeTransaccion;
            } catch (error) {
                this.setLoadingInitial(false);
                return CCTipoDeTransaccion;
            }
        }
    }

    private setCCTipoDeTransaccion = (CCTipoDeTransaccion: CCTipoDeTransaccion) => {
        this.CCTipoDeTransaccionRegistry.set(CCTipoDeTransaccion.codigoTipoTransaccion, CCTipoDeTransaccion);
    }

    getCCTipoDeTransaccion = (codigoTipoTransaccion: any) => {
        return this.CCTipoDeTransaccionRegistry.get(codigoTipoTransaccion);
    }

    setLoadingInitial = (state: boolean) => {
        this.loadingInitial = state;
    }

    createCCTipoDeTransaccion = async (CCTipoDeTransaccion: CCTiposDeTransaccionFormValues) => {
        try {
            await agent.CCTiposDeTransacciones.create(CCTipoDeTransaccion);
            runInAction(() => {
                this.selectedCCTipoDeTransaccion = CCTipoDeTransaccion;
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }

    updateCCTipoDeTransaccion = async (CCTipoDeTransaccion: CCTiposDeTransaccionFormValues) => {
        try {
            await agent.CCTiposDeTransacciones.update(CCTipoDeTransaccion);
            runInAction(() => {
                if (CCTipoDeTransaccion.codigoTipoTransaccion) {
                    let updateCCTipoDeTransaccion = {...this.getCCTipoDeTransaccion(CCTipoDeTransaccion.codigoTipoTransaccion), ...CCTipoDeTransaccion}
                    this.CCTipoDeTransaccionRegistry.set(CCTipoDeTransaccion.codigoTipoTransaccion, updateCCTipoDeTransaccion as CCTipoDeTransaccion);
                    this.selectedCCTipoDeTransaccion = updateCCTipoDeTransaccion as CCTipoDeTransaccion
                    this.loading = false;
                }
                   
            } )
        } catch (error) {
        }
    }

    deleteCCTipoDeTransaccion = async (codigoTipoTransaccion: string) => {
        this.loading = true;
        try {
            await agent.CCTiposDeTransacciones.delete(codigoTipoTransaccion);
            runInAction(() => {
                this.CCTipoDeTransaccionRegistry.delete(codigoTipoTransaccion);
                this.loading = false;
            })
        } catch (error) {
            runInAction(() => {
                this.loading = false;
            })
        }
    }


}